export const EVENTS = {
  PROFESSIONS_PAGE_CHANGE_CITY: "PROFESSIONS_PAGE_CHANGE_CITY",
  PROFESSIONS_PAGE_CHANGE_PROFESSION_TASK:
    "PROFESSIONS_PAGE_CHANGE_PROFESSION_TASK",
};
